import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const showAllQuestsAtom = atomWithStorage<boolean>('show-all-quests', false);

export const selectedQuestIdAtom = atom<number | undefined>(undefined);
export const setSelectedQuestIdAtom = atom(null, (_get, set, payload: number | undefined) => {
	set(selectedQuestIdAtom, payload);
});

export const selectedCampaignIdAtom = atom<number | undefined>(undefined);
export const setSelectedCampaignIdAtom = atom(null, (_get, set, payload: number | undefined) => {
	set(selectedCampaignIdAtom, payload);
});

export const isSelectedQuestPanelOpenAtom = atom(false);
export const setIsSelectedQuestPanelOpenAtom = atom(null, (_get, set, payload: boolean) => {
	set(isSelectedQuestPanelOpenAtom, payload);
});

export const isSelectedCampaignPanelOpenAtom = atom(false);
export const setIsSelectedCampaignPanelOpenAtom = atom(null, (_get, set, payload: boolean) => {
	set(isSelectedCampaignPanelOpenAtom, payload);
});

export const isSelectedQuestInCampaignPanelOpenAtom = atom(false);
export const setIsSelectedQuestInCampaignPanelOpenAtom = atom(null, (_get, set, payload: boolean) => {
	set(isSelectedQuestInCampaignPanelOpenAtom, payload);
});

export const isSelectedQuestInCampaignPanelActiveAtom = atom(false);
export const setIsSelectedQuestInCampaignPanelActiveAtom = atom(null, (_get, set, payload: boolean) => {
	set(isSelectedQuestInCampaignPanelActiveAtom, payload);
});

export const isSelectedQuestPanelActiveAtom = atom(false);
export const setIsSelectedQuestPanelActiveAtom = atom(null, (_get, set, payload: boolean) => {
	set(isSelectedQuestPanelActiveAtom, payload);
});

export const forceCloseModalAtom = atom<boolean>(false);
